module.exports = __webpack_public_path__ + "img/ideasfundx-fundraising.de21af87.png";